<template>
  <div class="rubric-preset-preview">
    <b-table
      :fields="fields"
      :items="rubricPresetUnit"
      small
      caption-top
      bordered
      show-empty
      :empty-text="$t('evaluations.newEvaluations.noAchievementLevelsToShow')"
    >
      <template #cell(description)="row">
        <RenderVHtml :content="row.item.description"></RenderVHtml>
      </template>
    </b-table>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "RubricPresetPreview",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    rubric_preset_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      rubric_presets: names.RUBRIC_PRESETS,
      rubric_preset_units: names.RUBRIC_PRESET_UNITS,
    }),
    rubricPreset() {
      return this.rubric_presets.find((x) => x.id == this.rubric_preset_id);
    },
    rubricPresetUnit() {
      return this.rubric_preset_units
        .filter((x) => x.rubric_preset == this.rubric_preset_id)
        .sort(function (a, b) {
          return a.score > b.score ? -1 : 1;
        });
    },
    fields() {
      return [
        {
          key: "title",
          label: this.$t("evaluations.newEvaluations.category").toUpperCase(),
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary)",
          },
          tdClass: "text-left",
        },
        {
          key: "score",
          label:
            this.rubricPreset && this.rubricPreset.show_percentage_sign
              ? this.$t(
                  "evaluations.newEvaluations.percentageAchievement"
                ).toUpperCase()
              : this.$t("evaluations.newEvaluations.score").toUpperCase(),
          tdClass: "text-center",
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary)",
            width: "100px",
          },
          formatter: (value) => {
            if (this.rubricPreset && this.rubricPreset.show_percentage_sign)
              return value + "%";
            else return value;
          },
        },
        {
          key: "description",
          label: this.$t(
            "evaluations.newEvaluations.achievementLevelsDescription"
          ).toUpperCase(),
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary)",
          },
          tdClass: "text-left",
        },
      ];
    },
  },
  methods: {},
  created() {},
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.rubric-preset-preview >>> table {
  font-family: var(--kl-font-family);
  font-size: var(--kl-table-fs);
  color: var(--kl-table-text);
  margin-bottom: 0;
}
.rubric-preset-preview >>> th {
  font-size: var(--kl-table-header-fs);
  font-weight: var(--kl-fw-bold);
  letter-spacing: var(--kl-ls-wide);
  vertical-align: middle;
}
.rubric-preset-preview >>> td,
.rubric-preset-preview >>> th {
  border-color: var(--kl-table-border) !important;
}
.rubric-preset-preview >>> td {
  background: var(--kl-table-row-bg);
  line-height: var(--kl-lh-base);
  vertical-align: middle;
}
.rubric-preset-preview >>> tbody tr:hover td {
  background: var(--kl-table-row-hover-bg);
}
</style>